export default __webpack_public_path__ + "static/google-maps-5601c337676eef6ab244b4cf37dc3ba1.png";